<template>
  <div
    class="my-form p-2"
    :style="`width:${typeof width === 'number' ? width + 'px' : width};`"
  >
    <b-overlay
      :show="loading"
      rounded="sm"
      class="form-box"
      :class="{ 'form-box-maxHeight': disabled || !footerVisible }"
    >
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <template v-for="column in columnsFormat">
              <b-col
                v-if="column.field !== 'originalStaffNo'"
                :key="column.field"
                :cols="option.hideSpan ? 12 : column.formOption.span || 12"
              >
                <b-form-group
                  :style="`margin-left: ${column.formOption.marginLeft}`"
                >
                  <label
                    v-if="
                      notShowLabelType.indexOf(column.type) == -1 &&
                        column.label
                    "
                    class="form-label"
                    :class="{ required: hasRequired(column.formOption) }"
                  >
                    <span style="white-space: pre-line;"
                      >{{ column.label }}
                    </span>
                  </label>

                  <div
                    v-if="
                      bootstrapHasType.indexOf(column.formOption.type) != -1
                    "
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="column.label"
                      :rules="column.formOption.rules"
                      :skip-if-empty="!isCheckboxValidationRules(column.formOption.rules)"
                    >
                      <div
                        v-if="
                          column.formOption.slot &&
                            $scopedSlots[`${column.field}Form`]
                        "
                      >
                        <slot
                          :name="`${column.field}Form`"
                          :data="form[column.field]"
                        />
                      </div>
                      <template v-else-if="!column.formOption.hide">
                        <template v-if="disabled || column.disabled">
                          <br /><span class="text-primary">{{
                            form[column.field]
                          }}</span>
                        </template>
                        <template v-else>
                          <b-form-input
                            v-if="column.bind"
                            :id="`v-${pageKey}-${column.field}`"
                            :value="getFormFieldVal(column)"
                            :state="errors.length > 0 ? false : null"
                            :placeholder="
                              $t('_components.placeholder.input') + column.label
                            "
                            :type="column.formOption.type"
                            :plaintext="disabled || column.disabled"
                            :max="column.formOption.numberMax"
                            :min="column.formOption.numberMin"
                            @input="setFormFieldVal($event, column)"
                          />
                          <b-form-input
                            v-else
                            :id="`v-${pageKey}-${column.field}`"
                            v-model="form[column.field]"
                            :state="errors.length > 0 ? false : null"
                            :placeholder="
                              $t('_components.placeholder.input') + column.label
                            "
                            :type="column.formOption.type"
                            :plaintext="disabled || column.disabled"
                            :max="column.formOption.numberMax"
                            :min="column.formOption.numberMin"
                          />
                        </template>
                      </template>
                      <template v-if="column.disabled && !form[column.field]">
                        <small class="text-primary">{{
                          column.formOption.small
                        }}</small>
                      </template>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                  <div v-else>
                    <validation-provider
                      class="ssaa"
                      #default="{ errors }"
                      :key="`${column.field}-${column.formOption.rules}`"
                      :name="column.label"
                      :rules="column.formOption.rules"
                      :skip-if-empty="!isCheckboxValidationRules(column.formOption.rules)"
                    >
                      <div
                        v-if="
                          column.formOption.slot &&
                            $scopedSlots[`${column.field}Form`]
                        "
                      >
                        <slot :name="`${column.field}Form`" :data="form" />
                      </div>
                      <div
                        v-else
                        :class="{ 'disable-form-group': column.disabled }"
                      >
                        <div
                          :class="{
                            'disable-form-control':
                              column.formOption.disableFormControl,
                          }"
                          :style="
                            column.formOption.disableFormControl
                              ? null
                              : { display: 'contents' }
                          "
                        >
                        <element-component
                          v-if="column.bind"
                          :id="`v-${pageKey}-${column.field}`"
                          :value="getFormFieldVal(column)"
                          :label="column.label"
                          :disabled="disabled || getDisabled(column)"
                          :state="errors.length > 0 ? false : null"
                          :option="column.formOption"
                          :item-data="data"
                          :field="column.field"
                          :loading.sync="componentLoading"
                          @input="setFormFieldVal($event, column)"
                          :formDataAll="form"
                        />

                        <div v-else>
                          <div v-if="column.field === 'mobile'">
                            <div v-if="disabled" class="text-primary">
                              {{ form.mobile }}
                            </div>
                            <div
                              v-else
                              :class="{
                                duplicatedBox: showMobileDuplicated,
                                NoduplicatedBox: showMobileSuccess,
                              }"
                            >
                              <el-input
                                placeholder="Mobile"
                                v-model="form.mobile"
                                type="number"
                                @input="mobileInput"
                              >
                                <el-select
                                  style="width: 90px"
                                  v-model="form.mobileCode"
                                  slot="prepend"
                                  filterable
                                  @change="mobileCodeChange"
                                  :filter-method="customFilter"
                                >
                                  <el-option
                                    v-for="country in filteredCountries"
                                    :key="country.code"
                                    :label="country.nameLabel"
                                    :value="country.zone"
                                  >
                                  </el-option>
                                </el-select>
                                <i
                                  v-if="showMobileSuccess"
                                  slot="append"
                                  class="el-icon-circle-check"
                                ></i>
                                <i
                                  v-if="showMobileDuplicated"
                                  slot="append"
                                  class="el-icon-circle-close"
                                ></i>
                              </el-input>
                              <div
                                v-if="showMobileDuplicated"
                                class="duplicated_msg"
                              >
                                The mobile you entered is duplicated
                              </div>
                            </div>
                          </div>
                          <div v-else-if="column.field === 'email'">
                            <div v-if="disabled" class="text-primary">
                              {{ form.email }}
                            </div>
                            <div
                              v-else
                              :class="{
                                duplicatedBox: showEmailDuplicated,
                                NoduplicatedBox: showEmailSuccess,
                              }"
                            >
                              <el-input
                                placeholder="Email"
                                v-model="form.email"
                              >
                                <i
                                  v-if="showEmailSuccess"
                                  slot="append"
                                  class="el-icon-circle-check"
                                ></i>
                                <i
                                  v-if="showEmailDuplicated"
                                  slot="append"
                                  class="el-icon-circle-close"
                                ></i>
                              </el-input>
                              <div
                                v-if="showEmailDuplicated"
                                class="duplicated_msg"
                              >
                                The Email you entered is duplicated
                              </div>
                            </div>
                          </div>
                          <div v-else-if="column.field === 'staffNo'">
                            <div v-if="disabled" class="text-primary">
                              {{ form.staffNo }}
                            </div>
                            <div
                              v-else
                              :class="{
                                duplicatedBox: showStaffNoDuplicated,
                                NoduplicatedBox: showStaffNoSuccess,
                              }"
                            >
                              <el-input
                                placeholder="EmployeeCode"
                                v-model="form.staffNo"
                                @input="StaffNoInput"
                              >
                                <i
                                  v-if="showStaffNoSuccess"
                                  slot="append"
                                  class="el-icon-circle-check"
                                ></i>
                                <i
                                  v-if="showStaffNoDuplicated"
                                  slot="append"
                                  class="el-icon-circle-close"
                                ></i>
                              </el-input>
                              <div
                                v-if="showStaffNoDuplicated"
                                class="duplicated_msg"
                              >
                                The EmployeeCode you entered is duplicated
                              </div>
                            </div>
                          </div>

                          <element-component
                            v-else
                            :id="`v-${pageKey}-${column.field}`"
                            v-model="form[column.field]"
                            :vacation-credit-detail-list="
                              vacationCreditDetailList
                            "
                            :dict-value="form[column.dictField]"
                            :label="column.label"
                            :disabled="disabled || getDisabled(column)"
                            :state="errors.length > 0 ? false : null"
                            :option="column.formOption"
                            :loading.sync="componentLoading"
                            :item-data="data"
                            :field="column.field"
                            :formDataAll="form"
                          />
                        </div>
                        </div>
                      </div>
                      <div v-if="column.disabled && !form[column.field]">
                        <small class="text-primary">{{
                          column.formOption.small
                        }}</small>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </b-form-group>
              </b-col>
            </template>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
    <!-- submit and reset -->
    <b-row v-if="!disabled && footerVisible">
      <b-col cols="12" class="my-form_btns">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-3"
          :disabled="loading"
          @click.prevent="validationForm"
        >
          {{ $t('_components.btns.submit') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          type="reset"
          variant="outline-secondary"
          :disabled="loading"
          @click="resetForm"
        >
          {{ $t('_components.btns.reset') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { deepClone } from '@/util/util'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required,
  email,
  confirmed,
  password,
  checkboxRequired,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ElementComponent from '../elementComponent.vue'
import countryCode from '@/util/mobileCode'
import { staff } from '@/api/staff/index'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // BFormCheckbox,
    BForm,
    BButton,
    ElementComponent,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  provide() {
    return {
      formId: this.formId,
      viewPageData: this.form,
    }
  },
  props: {
    pageKey: {
      type: String,
      default: null,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    vacationCreditDetailList: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    dataCody: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    formId: {
      type: String,
      default: null,
    },
    footerVisible: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, String],
      default: 500,
    },
  },
  data() {
    return {
      form: { mobileCode: '+65' }, // this.data || {},
      copyForm: deepClone(this.data) || {},
      columns: [],
      countries: [],
      filteredCountries: [],
      showMobileDuplicated: false,
      showMobileSuccess: false,
      showEmailDuplicated: false,
      showEmailSuccess: false,
      showStaffNoDuplicated: false,
      showStaffNoSuccess: false,
      mobileTimer: null,
      // 表单配置的默认值
      defaultFormOption: {
        slot: false, // 是否使用自定义插槽
        addHide: false, // 新增表单隐藏 默认 false
        editHide: false, // 修改表单隐藏 默认 false
        viewHide: false, // 预览表单隐藏 默认 false
        hide: false, // 是否隐藏
        type: 'text', // 类型
        value: '', // 默认值
        dictCode: '', // 目前已经封装字典: role
        dictBizCode: '', // 业务字典
        rules: '', // 可填: required|email|confirmed|password 传多个使用|分隔
        uploadLimit: 10, // 上传最大数量
        disabled: false, // 可编辑
        span: 12, // 栅格
        numberMax: '', // 当为number类型时最大值
        numberMin: '', // 当为number类型时最小值
        dictQuery: undefined, // dict 查询条件
        small: '',
      },
      bootstrapHasType: [
        'text',
        'datetime-local',
        'week',
        'email',
        'url',
        'search',
        'tel',
        'color',
      ],
      notShowLabelType: ['title', 'info'],
      // 规则
      required,
      password,
      email,
      confirmed,
      checkboxRequired,
      componentLoading: false,
    }
  },
  computed: {
    uniqueColumns() {
      const temp = deepClone(this.columns) || []
      let result = []
      function unique(arr1) {
        const res = new Map()
        return arr1.filter((a) => !res.has(a.field) && res.set(a.field, 1))
      }
      result = unique(temp)
      return result
    },
    columnsFormat() {
      const temp = []
      this.uniqueColumns.forEach((item) => {
        const t = item
        if (!t.formOption) {
          t.formOption = this.defaultFormOption
        } else {
          Object.keys(this.defaultFormOption).forEach((key) => {
            if (!Object.hasOwnProperty.call(t.formOption, key)) {
              t.formOption[key] = this.defaultFormOption[key]
            }
          })
          if (this.pageKey === 'edit') {
            t.formOption.value = ''
          }
          if (
            t.formOption.value &&
            (!this.form[t.field] || this.option.defaultValueFirst)
          ) {
            this.setFormValue(t.formOption.value, t)
            // this.form[t.field] = t.formOption.value
          }
        }
        if (t.formOption.label) {
          t.label = t.formOption.label
        }
        temp.push(t)
      })
      const result = temp.filter(
        (o) =>
          !o.formOption.hide &&
          o.field !== '_menu' &&
          !o.formOption[`${this.pageKey}Hide`]
      )
      return result
    },
    disabled() {
      return this.pageKey === 'view'
    },
  },
  watch: {
    data: {
      handler(e) {
        // Object.keys(e).forEach(key => {
        //   this.form[key] = e[key]
        // })
        const copy = deepClone(this.form)
        this.form = this.data
        Object.keys(copy).forEach((key) => {
          if (!this.form[key] && typeof this.form[key] !== 'boolean') {
            // this.form[key] = copy[key]
            this.$set(this.form, key, copy[key])
          }
        })
        this.$forceUpdate()
        // this.$emit('change', this.form)
      },
      immediate: true,
      deep: true,
    },
    'data.mobile': {
      handler(e) {
        console.log('sdemail')
        this.mobileInput(e)
      },
      deep: true,
      immediate: true,
    },
    'data.email': {
      handler(e) {
        this.emailInput(e)
      },
      deep: true,
      immediate: true,
    },
    'option.columns': {
      handler(e) {
        this.columns = e || []
        this.$forceUpdate()
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.option, 'aaaaaaaffaaa')
    })
    const newCountryCode = countryCode
    this.countries = newCountryCode
    this.filteredCountries = [...this.countries]
  },
  methods: {
    mobileInput(e) {
      clearTimeout(this.mobileTimer)
      this.mobileTimer = setTimeout(() => {
        if (e != '' && e != undefined && e != this.dataCody.mobile) {
          this.verifyContent(`${this.form.mobileCode} ${e}`, 1)
        } else {
          this.showMobileDuplicated = false
          this.showMobileSuccess = false
        }
      }, 1000)
    },
    mobileCodeChange(e) {
      clearTimeout(this.mobileTimer)
      this.mobileTimer = setTimeout(() => {
        if (e != '' && e != undefined && e != this.dataCody.mobileCode) {
          this.verifyContent(`${e} ${this.form.mobile}`, 1)
        } else {
          this.showMobileDuplicated = false
          this.showMobileSuccess = false
        }
      }, 1000)
    },
    emailInput(e) {
      clearTimeout(this.emailTimer)
      this.emailTimer = setTimeout(() => {
        if (e != '' && e != undefined && e != this.dataCody.email) {
          this.verifyContent(`${e}`, 2)
        } else {
          this.showEmailDuplicated = false
          this.showEmailSuccess = false
        }
      }, 1000)
    },
    StaffNoInput(e) {
      clearTimeout(this.staffNoTimer)
      this.staffNoTimer = setTimeout(() => {
        if (e != '' && e != undefined && e != this.dataCody.staffNo) {
          this.verifyContent(`${e}`, 0)
        } else {
          this.showStaffNoDuplicated = false
          this.showStaffNoSuccess = false
        }
      }, 1000)
    },
    verifyContent(content, type) {
      staff
        .verifyRepeat({
          verifyContent: content,
          verifyType: type,
        })
        .then((res) => {
          console.log(res)
          const haveSame = res.data.data
          if (type == 1) {
            this.showMobileDuplicated = haveSame
            this.showMobileSuccess = !haveSame
          }
          if (type == 2) {
            console.log('sdff email', haveSame)
            this.showEmailDuplicated = haveSame
            this.showEmailSuccess = !haveSame
          }
          if (type == 0) {
            console.log('sdff staffNo', haveSame)
            this.showStaffNoDuplicated = haveSame
            this.showStaffNoSuccess = !haveSame
          }
        })
    },
    isCheckboxValidationRules(rules = '') {
      return String(rules).indexOf('checkboxRequired') !== -1
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return (
        rules.indexOf('required') !== -1
        || this.isCheckboxValidationRules(rules)
      )
    },
    eval(data, str) {
      const arr = str.split('.')
      let res = data
      Object.keys(arr).forEach((i) => {
        if (res || typeof res === 'boolean') {
          res = res[arr[i]]
        }
      })
      return res
    },
    async validationForm() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        if (this.componentLoading) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.uploadIsLoading'),
              variant: 'danger',
            },
          })
          return false
        }
        this.$emit('submit', this.form)
        return this.form
      }
      return false
    },

    resetForm() {
      this.form = deepClone(this.copyForm)
      this.$refs.simpleRules.reset()
      this.$emit('reset', this.form)
    },
    getFormFieldVal(col) {
      return this.eval(this.form, col.bind)
      // const copyData = deepClone(this.data)
      // this.option.columns.forEach(item => {
      //   if (item.bind) {
      //     this.data[item.field] = this.eval(copyData, item.bind)
      //   }
      // })
    },
    setFormFieldVal(value, col) {
      const arr = col.bind.split('.')
      let res = this.form
      const keys = Object.keys(arr)
      keys.forEach((item, index) => {
        if (res) {
          if (index === keys.length - 1) {
            res[arr[item]] = value
          } else {
            res = res[arr[item]]
          }
        }
      })
      this.$emit('change', this.form)
    },
    customFilter(query) {
      // en: item.en,
      //   cn: item.cn,
      //   code: item.code,
      //   zone
      console.log(query)
      const searchTerm = query.toLowerCase()

      this.filteredCountries = this.countries.filter((country) => {
        return (
          country.en.toLowerCase().includes(searchTerm) || // 匹配国家名称
          country.cn.toLowerCase().includes(searchTerm) ||
          country.code.toLowerCase().includes(searchTerm) ||
          country.zone.toLowerCase().includes(searchTerm)
          // 匹配区号
        )
      })
    },
    setFormValue(value, col) {
      if (col.bind) {
        const arr = col.bind.split('.')
        let res = deepClone(this.form) || {}
        const copy = deepClone(this.form) || {}
        const keys = Object.keys(arr)
        keys.forEach((item, index) => {
          if (res) {
            if (index === keys.length - 1) {
              res[arr[item]] = value
            } else {
              res = res[arr[item]]
            }
          }
        })
        copy[arr[0]] = res
        this.form = copy
      } else {
        this.form[col.field] = value
      }
    },
    getDisabled(option) {
      let res = false
      if (typeof option.disabled === 'boolean') {
        res = option.disabled
      }
      if (typeof option.formOption[`${this.pageKey}Disabled`] === 'boolean') {
        res = option.formOption[`${this.pageKey}Disabled`]
      }
      if (
        option.formOption.disabled &&
        typeof option.formOption.disabled === 'boolean'
      ) {
        return option.formOption.disabled
      }
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/form/index.scss';
.my-form {
  height: 100%;
  position: relative;
  overflow: hidden;
  &_btns {
    left: 0;
    right: 0;
    position: absolute;
    bottom: 0;
    text-align: center;
    border-top: 1px solid #ebe9f1;
    background: #fff;
    padding: 1.5rem 0;
  }
  .form-box {
    height: calc(100% - 72px);
    overflow-y: auto;
    overflow-x: hidden;
    &-maxHeight {
      height: 100%;
    }
  }
}
.dark-layout {
  .my-form {
    &_btns {
      background: #283046;
    }
  }
}
.NoduplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #67c23a;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #67c23a;
    background-color: #fff;
    i {
      color: #67c23a !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #67c23a;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
.duplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #f56c6c;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #f56c6c;
    background-color: #fff;
    i {
      color: #f56c6c !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #f56c6c;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
.NoduplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #67c23a;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #67c23a;
    background-color: #fff;
    i {
      color: #67c23a !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #67c23a;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
.duplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #f56c6c;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #f56c6c;
    background-color: #fff;
    i {
      color: #f56c6c !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #f56c6c;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
</style>
